export default __webpack_public_path__ + "static/media/P1000_Micropipette.127f8f6a.svg";